<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{ Dates(datas.created_at) }}
          <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
          class="btn btn-primary change ">{{$t('Ўзгартириш')}}</button>
        </h4>
      </div>
      <div class="col-md-6 end">
        <router-link class="btn btn-danger" :to="{ path: '/calculation/index' }">
          <button type="button" class="closebutton">
          <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
      <div class="col-md-3 topheader">
        <span>
          <label>Товар</label>
          <v-select v-if="productlist != null" :filter-by="$store.state.myFilter" :disabled="changedisabled" :clearable="false"
            class="form-control-sm required" @search="query => (search = query)" :options="paginated" menu-props="auto"
            v-model="datas.product_id" :reduce="extra_name => extra_name.id" label="extra_name" @input="Productchanged()">
            <template #list-footer>
              <li style="text-align: center;font-weight:bold;">
                f4 {{ $t("умумий рўйхат") }}
              </li>
            </template>
            <template #selected-option-container="{option}">
              <div class="vs__selected">
                <span v-if="typeof option.extra_name === 'number'">{{
                  Label(option.extra_name)
                  }}</span><span v-else>{{ option.extra_name }}</span>
              </div>
            </template>
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes"></span>
              <button type="button" class="modallist" @click="Selectproduct(null)">
                <b-icon icon="three-dots"></b-icon>
              </button>
            </template>
            <template #selected-option="{ extra_name }">
              <div style="position: absolute">
                {{ extra_name }}
              </div>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                {{ $t("бўйича маьлумот йўқ") }}
                <button type="button" class="pluss" @click="CreateProduct(index, search)">
                  +</button><b>Insert</b>
              </template>
              <em style="opacity: 0.5" v-else>{{
                $t("Маьлумот йўқ")
                }}</em>
            </template>
            <template #search="{ search, searching }">
              <template v-if="searching">
                <em><b>{{ search }}</b></em>
                <input class="vs__search" v-bind="attributes" v-on="events" />
              </template>
            </template>
          </v-select>
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>{{$t('Ўлчов бирлик')}}</label>
          <input class="needt" :value="datas.unit" readonly :disabled="changedisabled" type="text">
        </span>
      </div>
      <div class="col-md-2 topheader">
        <span>
          <label>{{$t('Сони')}}</label>
          <input v-model="datas.count_all" :disabled="changedisabled" type="text">
        </span>
      </div>
      <div class="col-md-5 topheader">
        <span>
          <label>Комментарий</label>
          <input v-model="datas.comment" :disabled="changedisabled" class="needt" type="text">
        </span>
      </div>
    </div>
    <div class="table100percent">
      <md-card>
        <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="column3">№</th>
                <th>Товар</th>
                <th class="column3">{{$t('Ўлчов бирлик')}}</th>
                <th class="column3">{{ $t("Сони") }}</th>
                <th class="column3"></th>
              </tr>
            </thead>
            <tbody style="overflow:hidden">
              <div style="overflow-y: scroll; height: 60vh !important; width: 100%;">
                <tr :style="{ height: `${index / 1000 + 10}px` }" v-for="(item, index) in datas.calculation_table" :key="index">
                  <td class="column3">{{ index + 1 }}</td>
                  <td>
                    <v-select v-if="productlist != null" :filter-by="$store.state.myFilter" :disabled="changedisabled" :clearable="false"
                      class="form-control-sm required" @search="query => (search = query)" :options="paginated" @input="Productchangedchild(item)"
                      menu-props="auto" v-model="item.product_id" :reduce="extra_name => extra_name.id" label="extra_name">
                      <template #list-footer>
                        <li style="text-align: center;font-weight:bold;">
                          f4 {{ $t("умумий рўйхат") }}
                        </li>
                      </template>
                      <template #selected-option-container="{option}">
                        <div class="vs__selected">
                          <span v-if="typeof option.extra_name === 'number'">{{
                            Label(option.extra_name)
                            }}</span><span v-else>{{ option.extra_name }}</span>
                        </div>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"></span>
                        <button type="button" class="modallist" @click="Selectproduct(index)">
                          <b-icon icon="three-dots"></b-icon>
                        </button>
                      </template>
                      <template #selected-option="{ extra_name }">
                        <div style="position: absolute">
                          {{ extra_name }}
                        </div>
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          <em><b>{{ search }}</b></em>
                          {{ $t("бўйича маьлумот йўқ") }}
                          <button type="button" class="pluss" @click="CreateProduct(index, search)">
                            +</button><b>Insert</b>
                        </template>
                        <em style="opacity: 0.5" v-else>{{
                          $t("Маьлумот йўқ")
                          }}</em>
                      </template>
                      <template #search="{ search, searching }">
                        <template v-if="searching">
                          <em><b>{{ search }}</b></em>
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                        </template>
                      </template>
                    </v-select>
                  </td>
                  <td class="column3">
                              <input class="needt table-input" :value="item.unit" readonly :disabled="changedisabled" type="text">
                  </td>
                  <td class="column3">
                    <vue-numeric separator="space" v-model="item.count" :disabled="changedisabled" class="table-input" v-bind:precision="3"
                      @change="Changes(index)">
                    </vue-numeric>
                  </td>
                  <td class="column3">
                    <a href="javascript:void(0)" v-if="changedisabled==false" class="circul trash" @click="Trashitem(index)">
                      <b-icon icon="trash"></b-icon>
                    </a>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
        </md-card-content>
      </md-card>
    </div>
    <div class="row">
      <div class="col-md-7"></div>
      <div class="col-md-5 end formbottom">
        <button class="mybtn btn addrow needt" :disabled="changedisabled" type="button" @click="Addtable()">
          <b-icon icon="plus-lg"></b-icon><sup>F1</sup>
        </button>
        <button class="mybtn btn saved needt" v-if="changedisabled==false" type="button" @click="Savedokument()">
          {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import { print } from "../../components/mixins/print.js";
  export default {
    name: "CalculationForm",
    mixins: [print],
    data() {
      return {
        settedindex: null,
        productlist: []
      };
    },
    props: ["datas"],
    created: function () {
      let self = this;
      self.$root.$refs.calculation = self;
      (window.onstorage = () => {
        if (localStorage.getItem("setted_product") > 0) {
          this.Productlist();
          if (this.$store.state.selected_index != null) {
            this.datas.calculation_table[this.$store.state.selected_index].product_id = parseInt(localStorage.getItem("setted_product"));
            this.Productchangedchild(this.datas.calculation_table[this.$store.state.selected_index]);
            // this.Productchange(this.$store.state.selected_index);
          } else {
            this.datas.product_id = parseInt(localStorage.getItem("setted_product"));
            this.Productchanged();
          }
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }
      });
    },
    mounted: function () {
      this.Focus();
      this.SetRule('/calculation/index');
    },
    methods: {
      Productchanged(){
        let self=this;
        axios({
            method: "get",
            url: "api/v1/product/id/" + self.datas.product_id
          }).then(function (response) {
            if(response.data.unit!=null){
            self.datas.unit=response.data.unit.name;
            }else{
              self.datas.unit="";
            }
          });
      },
      Productchangedchild(item){
        let self=this;
        axios({
            method: "get",
            url: "api/v1/product/id/" + item.product_id
          }).then(function (response) {
            if(response.data.unit!=null){
            item.unit=response.data.unit.name;
            }else{
              item.unit="";
            }
          });
      },
      CreateProduct(index, search) {
        localStorage.setItem("product_name", search);
        // localStorage.setItem("shtrix_code", this.datas.prixod_table[index].shtrix_kod);
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал create" });
        window.open(routeData.href, "_blank", "width=1400, height=1000");
      },
      Selectproduct(index) {
        this.$store.state.selected_index = index;
        let routeData = this.$router.resolve({ name: "Товар модал" });
        window.open(routeData.href, "_blank", "width=1200, height=1000");
      },
      Changes(index) {
        if (this.datas.calculation_table.length == index + 1) {
          this.Addtable();
        }
      },
      handlerClose: function (event) {
        if (this.$store.state.saved == null) {
          this.$store.state.saved = null;
        } else {
          const answer = window.confirm(
            this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
          );
          if (answer) {
            this.Savedokument();
            event.returnValue = "";
          } else {
            this.$store.state.saved = null;
          }
        }
      },
      Trashitem(index) {
        const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
        if (answer) {
          this.datas.calculation_table.splice(index, 1);
        }
      },
      Focus() {
        if (this.$route.path == "/calculation/create") {
          $('.vs__search').eq(0).focus();
        } else {
          setTimeout(() => {
            $('.vs__search').eq(1).focus();
          }, 100);
        }
      },
      Addtable() {
        this.datas.calculation_table.push({ product_id: 0, count: 0,unit:"" });
        this.Tablefocus();
      },
      Savedokument() {
        let self = this;
        // if (self.rule.open == true) {
          if (this.$route.path == "/calculation/create") {
            var methods = "post";
            var action = "api/v1/calculation";
          } else {
            self.datas.updated_at = new Date()
              .valueOf()
              .toString()
              .slice(0, 10);
            var methods = "patch";
            var action = "api/v1/calculation/id/" + self.$route.params.id;
          }
          axios({
            method: methods,
            url: action,
            data: self.datas
          }).then(function (response) {
            self.$store.state.saved = null;
            self.$router.push({ name: "Калкулация" });
          });
        // } else {
        //   self.$store.state.errors = self.$t('Sizdan bunday xuquq mavjud emas');
        // }
      }
    }
  };
</script>
<style lang="scss" scoped>
  .md-card-content>.table.table-bordered tbody {
    display: block;
    height: 70vh;
    overflow-y: scroll;
  }

  .md-card-content>.table.table-bordered thead,
  .md-card-content>.table.table-bordered tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
</style>